import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import SchemaOrg from '@/components/feature/SchemaOrg';
import { stats } from '@/mocks/promotions';

const aboutSchema = {
  '@context': 'https://schema.org',
  '@type': 'AboutPage',
  name: '关于新葡京娱乐城',
  description: '新葡京娱乐城是顶级在线娱乐平台，提供真人百家乐、老虎机、体育竞猜等多元游戏。了解我们的品牌故事、信誉保障与联系方式。',
  url: 'https://sportsinn.github.io/about',
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '新葡京娱乐城',
  url: 'https://sportsinn.github.io',
  description: '新葡京娱乐城是顶级在线娱乐平台，提供真人百家乐、老虎机、体育竞猜等多元游戏。安全可靠、存取款便捷、24小时客服在线。',
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '+853-2888-8888',
    contactType: 'customer service',
    availableLanguage: ['Chinese'],
  },
};

export default function About() {
  const [contactForm, setContactForm] = useState({
    name: '',
    email: '',
    message: '',
    websiteAlt: '',
  });
  const [formStatus, setFormStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [formErrorMsg, setFormErrorMsg] = useState('');

  const handleContactSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (contactForm.websiteAlt.trim()) {
      setFormStatus('success');
      setContactForm({ name: '', email: '', message: '', websiteAlt: '' });
      return;
    }
    setFormStatus('idle');
    setFormErrorMsg('');

    try {
      const formData = new FormData(e.currentTarget as HTMLFormElement);
      formData.delete('website_alt');
      const response = await fetch('https://readdy.ai/api/form/d9tgu9v8l97n3eas39rg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }
      if (response.ok && parsed?.code === 'OK') {
        setFormStatus('success');
        setContactForm({ name: '', email: '', message: '', websiteAlt: '' });
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || '提交失败';
        setFormStatus('error');
        setFormErrorMsg(serverMsg);
      }
    } catch {
      setFormStatus('error');
      setFormErrorMsg('网络错误，请稍后重试');
    }
  };

  return (
    <>
      <SchemaOrg schema={aboutSchema} />
      <SchemaOrg schema={orgSchema} />
      <Navbar />
      <main className="pt-16">
        <Breadcrumb items={[{ label: '关于我们' }]} />

        <section className="relative w-full h-[350px] md:h-[400px] overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Luxury%20grand%20casino%20interior%20with%20golden%20pillars%20and%20chandeliers%2C%20dark%20elegant%20atmosphere%2C%20warm%20lighting%2C%20premium%20architectural%20design%2C%20red%20and%20gold%20color%20scheme%2C%20sophisticated%20editorial%20photography&width=1920&height=800&seq=about-hero-casino&orientation=landscape"
            alt="新葡京娱乐城 - 品牌介绍"
            className="absolute inset-0 w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 to-black/60"></div>
          <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-4">
            <h1 className="text-2xl md:text-4xl font-heading font-bold text-white mb-3">
              关于新葡京娱乐城
            </h1>
            <p className="text-sm md:text-base text-white/70 max-w-xl">
              顶级在线娱乐平台，值得您信赖
            </p>
          </div>
        </section>

        <section className="w-full py-16 md:py-20 bg-background-50">
          <div className="w-full px-4 md:px-6 max-w-5xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div>
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-6">
                  品牌介绍
                </h2>
                <div className="flex flex-col gap-4 text-foreground-700 leading-relaxed">
                  <p>
                    <strong>新葡京娱乐城</strong>成立于2010年，是亚洲领先的在线娱乐平台之一。我们致力于为全球玩家提供安全、公平、优质的一站式在线娱乐服务。
                  </p>
                  <p>
                    平台拥有超过<strong>500款精选游戏</strong>，涵盖真人娱乐、老虎机、体育竞猜、彩票、棋牌等全品类。无论是追求刺激的资深玩家，还是初次尝试的新手用户，都能在新葡京娱乐城找到属于自己的乐趣。
                  </p>
                  <p>
                    我们与全球顶尖游戏开发商建立了长期合作关系，所有游戏均采用<strong>国际认证的随机数生成器（RNG）</strong>，确保每一局游戏的结果公平公正、不可操控。
                  </p>
                  <p>
                    经过十余年的发展，新葡京娱乐城已累计服务超过<strong>500万注册会员</strong>，赢得了广大玩家的信赖与好评。
                  </p>
                </div>
              </div>
              <div className="rounded-lg overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Luxury%20casino%20brand%20building%20exterior%20at%20night%20with%20golden%20illumination%2C%20grand%20architecture%2C%20elegant%20design%2C%20dark%20sky%2C%20premium%20atmosphere%2C%20dramatic%20lighting%2C%20editorial%20photography&width=800&height=600&seq=about-brand-casino&orientation=landscape"
                  alt="新葡京娱乐城品牌形象"
                  className="w-full h-full object-cover object-center"
                />
              </div>
            </div>
          </div>
        </section>

        <section className="w-full py-16 md:py-20 bg-background-100">
          <div className="w-full px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
                平台数据
              </h2>
              <p className="text-foreground-500 text-sm">数字见证我们的实力</p>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 max-w-4xl mx-auto">
              {stats.map((stat) => (
                <div
                  key={stat.label}
                  className="text-center p-6 rounded-lg bg-background-50"
                >
                  <div className="text-2xl md:text-3xl font-heading font-bold text-primary-600 mb-2">
                    {stat.value}
                  </div>
                  <div className="text-sm text-foreground-500">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full py-16 md:py-20 bg-background-50">
          <div className="w-full px-4 md:px-6 max-w-5xl mx-auto">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2 text-center">
              信誉保障
            </h2>
            <p className="text-foreground-500 text-sm text-center mb-12">
              多重保障让您放心娱乐
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {[
                {
                  title: '合法运营牌照',
                  desc: '新葡京娱乐城持有国际认可的合法在线娱乐运营牌照，受相关监管机构严格监督，确保平台运营合规合法。',
                  icon: 'ri-verified-badge-line',
                },
                {
                  title: '资金安全保障',
                  desc: '采用银行级SSL加密技术和多重风控体系，所有资金交易均有严格审核流程，保障玩家资金万无一失。',
                  icon: 'ri-safe-2-line',
                },
                {
                  title: '游戏公平认证',
                  desc: '所有游戏均通过国际权威机构BMM Testlabs认证，随机数生成器定期接受第三方独立审计。',
                  icon: 'ri-award-line',
                },
                {
                  title: '隐私数据保护',
                  desc: '严格遵守国际数据保护法规，玩家个人信息和游戏数据均采用加密存储，绝不外泄。',
                  icon: 'ri-lock-line',
                },
              ].map((item) => (
                <div
                  key={item.title}
                  className="flex gap-4 p-6 rounded-lg bg-background-100"
                >
                  <div className="w-12 h-12 flex-shrink-0 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                    <i className={`${item.icon} text-xl`}></i>
                  </div>
                  <div>
                    <h3 className="text-base font-semibold text-foreground-900 mb-2">
                      {item.title}
                    </h3>
                    <p className="text-sm text-foreground-500 leading-relaxed">
                      {item.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full py-16 md:py-20 bg-background-100">
          <div className="w-full px-4 md:px-6 max-w-5xl mx-auto">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2 text-center">
              联系我们
            </h2>
            <p className="text-foreground-500 text-sm text-center mb-12">
              如有任何疑问，欢迎随时联系我们
            </p>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
              <div className="flex flex-col gap-6">
                {[
                  { icon: 'ri-phone-line', label: '客服热线', value: '+853-2888-8888' },
                  { icon: 'ri-mail-line', label: '电子邮箱', value: 'service@xinpujing.com' },
                  { icon: 'ri-time-line', label: '服务时间', value: '7×24小时全天候服务' },
                  { icon: 'ri-message-3-line', label: '在线客服', value: '网站右下角在线聊天' },
                ].map((item) => (
                  <div key={item.label} className="flex items-center gap-4">
                    <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                      <i className={`${item.icon} text-lg`}></i>
                    </div>
                    <div>
                      <div className="text-xs text-foreground-400 mb-0.5">{item.label}</div>
                      <div className="text-sm font-medium text-foreground-900">{item.value}</div>
                    </div>
                  </div>
                ))}
              </div>

              <div className="bg-background-50 rounded-lg p-6">
                <h3 className="text-lg font-semibold text-foreground-900 mb-5">
                  在线留言
                </h3>
                <form onSubmit={handleContactSubmit} className="flex flex-col gap-4" data-readdy-form>
                  <input
                    type="text"
                    name="website_alt"
                    value={contactForm.websiteAlt}
                    onChange={(e) => setContactForm({ ...contactForm, websiteAlt: e.target.value })}
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                    readOnly
                    className="honeypot-field"
                  />
                  <div>
                    <label htmlFor="contact-name" className="block text-sm text-foreground-700 mb-1.5">
                      姓名
                    </label>
                    <input
                      id="contact-name"
                      name="name"
                      type="text"
                      required
                      value={contactForm.name}
                      onChange={(e) => setContactForm({ ...contactForm, name: e.target.value })}
                      className="w-full px-4 py-2.5 text-sm rounded-md border border-background-300 bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-400 transition-colors"
                      placeholder="请输入您的姓名"
                    />
                  </div>
                  <div>
                    <label htmlFor="contact-email" className="block text-sm text-foreground-700 mb-1.5">
                      邮箱
                    </label>
                    <input
                      id="contact-email"
                      name="email"
                      type="email"
                      required
                      value={contactForm.email}
                      onChange={(e) => setContactForm({ ...contactForm, email: e.target.value })}
                      className="w-full px-4 py-2.5 text-sm rounded-md border border-background-300 bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-400 transition-colors"
                      placeholder="请输入您的邮箱"
                    />
                  </div>
                  <div>
                    <label htmlFor="contact-message" className="block text-sm text-foreground-700 mb-1.5">
                      留言内容
                    </label>
                    <textarea
                      id="contact-message"
                      name="message"
                      required
                      value={contactForm.message}
                      onChange={(e) => setContactForm({ ...contactForm, message: e.target.value })}
                      className="w-full px-4 py-2.5 text-sm rounded-md border border-background-300 bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-400 transition-colors resize-none"
                      rows={4}
                      maxLength={500}
                      placeholder="请输入您的留言内容（500字以内）"
                    ></textarea>
                  </div>
                  <button
                    type="submit"
                    className="w-full px-6 py-2.5 bg-primary-500 text-background-50 font-medium rounded-md hover:bg-primary-600 transition-colors text-sm whitespace-nowrap cursor-pointer"
                  >
                    提交留言
                  </button>
                  {formStatus === 'success' && (
                    <p className="text-sm text-green-600 text-center">感谢您的留言，我们会尽快回复您！</p>
                  )}
                  {formStatus === 'error' && (
                    <p className="text-sm text-accent-600 text-center">{formErrorMsg}</p>
                  )}
                </form>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}